import { palette, animations } from '../../theme';

export const mobileWeekPickerStyles = {
  wrapper: {
    width: '100%',
    height: '500px',
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    overflowY: 'auto' as const,
    paddingBottom: '40px',
    ...animations.appearanceEffect,
  },

  header: {
    marginBottom: '16px',
    padding: '12px 24px',
    backgroundColor: 'transparent',
    color: palette.primary.main,
    borderRadius: '8px',
    fontWeight: 'bold',
    fontSize: '16px',
    textAlign: 'center' as const,
  },

  pickerDay: {
    selectedWeek: {
      backgroundColor: palette.primary.main,
      color: palette.background.paper,
      fontWeight: 'bold',
      fontSize: '14px',
      padding: '10px 6px',
      minWidth: '40px',
      width: '40px',
      height: '40px',
      borderRadius: '0px',
      margin: '0',
      position: 'relative' as const,
      zIndex: 1,
      '&:hover': {
        backgroundColor: palette.primary.main,
        color: palette.background.paper,
      },
      '&.Mui-selected': {
        backgroundColor: palette.primary.main,
        color: palette.background.paper,
      },
      '&.Mui-selected:hover': {
        backgroundColor: palette.primary.main,
        color: palette.background.paper,
      },
    },

    firstDayOfWeek: {
      borderTopLeftRadius: '6px',
      borderBottomLeftRadius: '6px',
      borderTopRightRadius: '0px',
      borderBottomRightRadius: '0px',
    },

    lastDayOfWeek: {
      borderTopLeftRadius: '0px',
      borderBottomLeftRadius: '0px',
      borderTopRightRadius: '6px',
      borderBottomRightRadius: '6px',
    },
  },
};
